export default __webpack_public_path__ + "static/10-f7a6771c3b0529c17380ef5ae09f8a39.png";